import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { reactive, computed, onMounted } from 'vue'
import { UserOutlined, LockOutlined, MobileOutlined } from '@ant-design/icons-vue';
import { postTeacherApi } from '@/servers/api/teacher';
import { postUserApi, postUserLogin } from '@/servers/api/user';
import { putClassesDetailApi } from '@/servers/api/classes';
import router from '@/router';
import { useUserStore } from '@/store';
import { message } from 'ant-design-vue';
import { useSchoolSelection } from '@/composables/useSchoolSelection';

// 使用共用的学校/年级/班级选择逻辑
interface FormParams {
  uid: string
  password: string
  name: string
  phone: string
  schoolName: string
  schoolId: string
  grade: string
  subject: string
  classId: number | undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherRegister',
  setup(__props) {

const {
  schoolList,
  gradeList,
  classList,
  fetchGradesBySchool,
  fetchClassesByGrade,
  loadSchoolData,
} = useSchoolSelection();

// 表单参数
const disabled = computed(() => {
  return !(formparams.uid && formparams.password && formparams.name && formparams.phone && formparams.schoolId && formparams.grade && formparams.subject && formparams.classId);
});

const formparams = reactive<FormParams>({
  uid: '',
  password: '',
  name: '',
  phone: '',
  schoolName: '',
  schoolId: '',
  schoolId: '',
  grade: '',
  subject: '',
  classId: undefined
})

const userStore = useUserStore();

// 学校选择事件处理
const handleSchoolChange = async (value: string) => {
  formparams.schoolId = value;
  // 同时保存学校名称
  const selectedSchool = schoolList.value.find(s => s.school_id === value);
  formparams.schoolName = selectedSchool ? selectedSchool.name : '';
  formparams.grade = '';
  formparams.classId = undefined;
  await fetchGradesBySchool(value);
};

// 年级选择事件处理
const handleGradeChange = async (value: string) => {
  formparams.grade = value;
  formparams.classId = undefined;
  await fetchClassesByGrade(formparams.schoolId, value);
  // 默认选中第一个班级
  if (classList.value.length > 0) {
    formparams.classId = classList.value[0].id;
  }
};

// 提交表单
const onFinish = async (values: any) => {
  try {
    // 直接使用表单中的学校ID
    const schoolId = formparams.schoolId;
    
    // 注册教师信息
    const teacherData = {
      uid: formparams.uid,
      name: formparams.name,
      subject: formparams.subject,
      school_id: schoolId
    };
    
    const teacherRes = await postTeacherApi(teacherData);
    console.log('Teacher registration response:', teacherRes);
    if (teacherRes.code !== 200) {
      message.error('教师信息注册失败！');
      return;
    }

    // 注册用户信息
    const userData = {
      email: formparams.uid, // 使用账号作为邮箱
      password: formparams.password,
      name: formparams.name,
      phone: formparams.phone,
      school_id: schoolId,
      role: formparams.uid, // 使用账号作为角色标识
      bind_state: true,
    };
    
    const registerRes = await postUserApi(userData);
    if (registerRes.code !== 200) {
      message.error('用户注册失败！');
      return;
    }
    
    message.success('注册成功！');
    
    // 自动登录
    const loginRes = await postUserLogin({
      email: formparams.uid,
      password: formparams.password
    });
    
    if (loginRes.code !== 200) {
      message.error('自动登录失败，请手动登录');
      router.push('/user/login');
      return;
    }
    
    // 存储用户信息和token
    localStorage.setItem('user', JSON.stringify(loginRes.data));
    localStorage.setItem('token', loginRes.data.token);
    userStore.setUserInfo({
      ...loginRes.data,
      token: loginRes.data.token
    });

    // 登录成功后，更新班级的班主任信息（此时有token）
    if (formparams.classId) {
      try {
        await putClassesDetailApi(
          { class_id: formparams.classId },
          { header: formparams.uid }
        );
        console.log('班级班主任绑定成功');
      } catch (error) {
        console.error('班级班主任绑定失败:', error);
        message.error('班级班主任绑定失败！');
        return;
      }
    }
    
    message.success('注册并登录成功！');
    router.push('/teacher_info');
  } catch (error: any) {
    console.error('注册过程出错:', error);
    const status = error?.response?.status;
    const reqUrl = String(error?.response?.url || '');
    if (status === 400) {
      if (reqUrl.includes('/api/teacher')) {
        message.error('该教师工号已注册，请直接登录或更换工号');
      } else if (reqUrl.includes('/api/user')) {
        message.error('该登录账号已存在，请直接登录或更换账号');
      } else {
        message.error('提交信息有误或账号已存在，请检查后重试');
      }
    } else if (status === 401) {
      message.error('认证失败，请重试');
    } else if (status >= 500) {
      message.error('服务器繁忙，请稍后再试');
    } else {
      message.error('注册失败，请检查网络或联系管理员');
    }
  }
}

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo)
  message.error('注册失败！');
}

// 组件挂载时加载学校数据
onMounted(() => {
  loadSchoolData();
});


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("h2", null, "教师账号注册", -1)),
    _createVNode(_component_a_form, {
      model: formparams,
      name: "teacher_register",
      class: "register-form",
      onFinish: onFinish,
      onFinishFailed: onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "账号",
          name: "uid",
          rules: [
            { required: true, message: '请输入7位数账号!' },
            { pattern: /^\d{7}$/, message: '账号必须为7位数字' }
         ]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.uid,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formparams.uid) = $event)),
              placeholder: "请输入7位数账号"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(UserOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "密码",
          name: "password",
          rules: [{ required: true, message: '请输入密码!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: formparams.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formparams.password) = $event)),
              placeholder: "请输入密码"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(LockOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "教师姓名",
          name: "name",
          rules: [{ required: true, message: '请输入真实姓名!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.name,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formparams.name) = $event)),
              placeholder: "请输入教师姓名"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(UserOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "联系方式",
          name: "phone",
          rules: [{ required: true, message: '请输入联系方式!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formparams.phone,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formparams.phone) = $event)),
              placeholder: "请输入联系方式"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(MobileOutlined), { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "所在学校",
          name: "schoolId",
          rules: [{ required: true, message: '请选择学校!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.schoolId,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formparams.schoolId) = $event)),
              onChange: handleSchoolChange,
              style: {"width":"100%"},
              placeholder: "请选择学校",
              loading: _unref(schoolList).length === 0
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolList), (school) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: school.school_id,
                    value: school.school_id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(school.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "所在年级",
          name: "grade",
          rules: [{ required: true, message: '请选择年级!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.grade,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formparams.grade) = $event)),
              onChange: handleGradeChange,
              style: {"width":"100%"},
              placeholder: "请选择年级",
              loading: _unref(gradeList).length === 0 && formparams.schoolId,
              disabled: !formparams.schoolId
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (grade) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: grade,
                    value: grade
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(grade), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "任教学科",
          name: "subject",
          rules: [{ required: true, message: '请选择任教学科!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.subject,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formparams.subject) = $event)),
              style: {"width":"100%"},
              placeholder: "请选择任教学科"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "语文" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("语文", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "数学" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("数学", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "英语" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("英语", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "物理" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("物理", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "化学" }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("化学", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "生物" }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("生物", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "政治" }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("政治", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "历史" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("历史", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "地理" }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("地理", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "绑定班级",
          name: "classId",
          rules: [{ required: true, message: '请选择班级!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: formparams.classId,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formparams.classId) = $event)),
              style: {"width":"100%"},
              placeholder: "请选择班级",
              loading: _unref(classList).length === 0 && formparams.grade,
              disabled: !formparams.grade
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classList), (cls) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: cls.id,
                    value: cls.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cls.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              disabled: disabled.value,
              type: "primary",
              "html-type": "submit",
              class: "login-form-button"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" 注册 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _cache[19] || (_cache[19] = _createTextVNode(" 或者 ", -1)),
            _createVNode(_component_router_link, { to: "/user/login" }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("登录", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})